<template>
  <v-menu
    location="bottom end"
    :close-on-content-click="true"
    transition="tickets-action-menu-transition"
    content-class="tickets-action-menu__overlay"
  >
    <template v-slot:activator="{ props: menuProps }">
      <v-btn
        icon
        flat
        class="tickets-action-menu__trigger"
        v-bind="menuProps"
        @click.stop="$emit('trigger', $event)"
      >
        <v-icon size="20">mdi-dots-vertical</v-icon>
      </v-btn>
    </template>
    <v-card class="tickets-action-menu__card" elevation="0">
      <v-list density="compact" nav class="tickets-action-menu__list">
        <slot />
      </v-list>
    </v-card>
  </v-menu>
</template>

<script>
export default {
  name: "TicketsActionMenu",
  emits: ["trigger"],
};
</script>
